export default __webpack_public_path__ + "static/media/img4.d4650fc2.png";